/**
 * サイドバー開閉トグルアイコン
 * @param {object} props
 * @param {string} [props.stroke='#0073BC'] - アイコンの stroke カラー
 */
const SidebarIcon = ({ stroke = '#0073BC' }) => (
  <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 2H10.5" stroke={stroke} />
    <path d="M13.5 2H14.5" stroke={stroke} />
    <circle cx="12" cy="2" r="1.5" stroke={stroke} />
    <path d="M0 12L8.5 12" stroke={stroke} />
    <path d="M11.5 12L14.5 12" stroke={stroke} />
    <circle cx="10" cy="12" r="1.5" stroke={stroke} />
    <path d="M0 7L4 7" stroke={stroke} />
    <path d="M6.5 7H14.5" stroke={stroke} />
    <circle cx="5" cy="7" r="1.5" stroke={stroke} />
  </svg>
);

export default SidebarIcon;
